/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BlogManagerCreateArticleRequest } from '../models/BlogManagerCreateArticleRequest';
import type { BlogManagerCreateArticleResponseApiRespoonse } from '../models/BlogManagerCreateArticleResponseApiRespoonse';
import type { BlogManagerDeleteArticleRequest } from '../models/BlogManagerDeleteArticleRequest';
import type { BlogManagerDeleteArticleResponseApiRespoonse } from '../models/BlogManagerDeleteArticleResponseApiRespoonse';
import type { BlogManagerEditArticleRequest } from '../models/BlogManagerEditArticleRequest';
import type { BlogManagerEditArticleResponseApiRespoonse } from '../models/BlogManagerEditArticleResponseApiRespoonse';
import type { BlogManagerGetImageRequest } from '../models/BlogManagerGetImageRequest';
import type { BlogManagerGetImageResponseApiRespoonse } from '../models/BlogManagerGetImageResponseApiRespoonse';
import type { BlogManagerListArticleRequest } from '../models/BlogManagerListArticleRequest';
import type { BlogManagerListArticleResponseApiRespoonse } from '../models/BlogManagerListArticleResponseApiRespoonse';
import type { BlogManagerNextArticleRequest } from '../models/BlogManagerNextArticleRequest';
import type { BlogManagerNextArticleResponseApiRespoonse } from '../models/BlogManagerNextArticleResponseApiRespoonse';
import type { BlogManagerPreviewArticleRequest } from '../models/BlogManagerPreviewArticleRequest';
import type { BlogManagerPreviewArticleResponseApiRespoonse } from '../models/BlogManagerPreviewArticleResponseApiRespoonse';
import type { BlogManagerShowArticleRequest } from '../models/BlogManagerShowArticleRequest';
import type { BlogManagerShowArticleResponseApiRespoonse } from '../models/BlogManagerShowArticleResponseApiRespoonse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BlogManagerArticleService {

    /**
     * 投稿一覧
     * @param requestBody
     * @returns BlogManagerListArticleResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminArticle(
        requestBody: BlogManagerListArticleRequest,
    ): CancelablePromise<BlogManagerListArticleResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/article',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 投稿の新規登録
     * @param requestBody
     * @returns BlogManagerCreateArticleResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminArticleCreate(
        requestBody: BlogManagerCreateArticleRequest,
    ): CancelablePromise<BlogManagerCreateArticleResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/article/create',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 投稿の更新
     * @param requestBody
     * @returns BlogManagerEditArticleResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminArticleEdit(
        requestBody: BlogManagerEditArticleRequest,
    ): CancelablePromise<BlogManagerEditArticleResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/article/edit',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 投稿の削除
     * @param requestBody
     * @returns BlogManagerDeleteArticleResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminArticleDelete(
        requestBody: BlogManagerDeleteArticleRequest,
    ): CancelablePromise<BlogManagerDeleteArticleResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/article/delete',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 投稿プレビュー
     * @param requestBody
     * @returns BlogManagerPreviewArticleResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminArticlePreview(
        requestBody: BlogManagerPreviewArticleRequest,
    ): CancelablePromise<BlogManagerPreviewArticleResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/article/preview',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 画像情報取得
     * @param requestBody
     * @returns BlogManagerGetImageResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminArticleImage(
        requestBody: BlogManagerGetImageRequest,
    ): CancelablePromise<BlogManagerGetImageResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/article/image',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 投稿プレビュー
     * @param requestBody
     * @returns BlogManagerNextArticleResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminArticleNext(
        requestBody: BlogManagerNextArticleRequest,
    ): CancelablePromise<BlogManagerNextArticleResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/article/next',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 投稿表示
     * @param requestBody
     * @returns BlogManagerShowArticleResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminArticleShow(
        requestBody: BlogManagerShowArticleRequest,
    ): CancelablePromise<BlogManagerShowArticleResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/article/show',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

}
